/**
 * A teacher's note on a recording sits in one slot (`submissions.notes`,
 * `ai_tutor_attempts.teacher_audio_url`) and is a voice clip or a video. Videos
 * are uploaded as video-message_<teacher>_<time>.<ext>; voice clips never are.
 */
export const isVideoNote = (url) =>
  typeof url === 'string' && /\/video-message_[^/]*$/.test(url.split(/[?#]/)[0]);
